export enum AnalyticsID {
  GTM = 'gtm',
  ConvergePixel = 'converge-pixel',
  Converge = 'run_converge',
  Vercel = 'vercel',
  CookieBot = 'cookiebot',
  CookieBotCallbacks = 'cookiebotCallbacks',
  PolarSdk = 'polarsdk',
}

export enum CartUpsell {
  OTP2SUB_DISPLAY = 'otpToSub_display',
  OTP2SUB_ACCEPTED = 'otpToSub_accepted',
  NEXT_SUB_DISPLAY = 'nextSub_display',
  NEXT_SUB_ACCEPTED = 'nextSub_accepted',
}

export const VENDOR = 'Timeline';
